import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/membership/")({
  loader: () => {
    throw redirect({ to: '/membership/applications' })
  },
})
